import React from "react";
import DefaultCurrencyFormat from "../DefaultCurrencyFormat";
import { useTranslation } from "../../context/TranslationContext";
import ServiceRow from "./ServiceRow";
import DiscountBannerMobile from "../DiscountBannerMobile";

const Result = ({
  result,
  buyPool,
  paymentType,
  mandatoryServices = [],
  optionalServices = [],
  selectedServices,
  handleServiceChange,
  AvailableExtraServices,
  isAppWebView,
}) => {
  const {
    reservationSummary,
    accommodationAmount,
    remainingAmount,
    cleaningFee,
    totalPrice,
    depositPrice,
    discount,
    discountedAccommodationAmount,
    mobileAppDiscount,
    promoCodeDiscount,
    heatedPool,
    free,
    optionalServices: optionalServicesTitle,
  } = useTranslation();

  const filtered = result?.result?.isitmaUcretleri?.filter(
    (x) => x.isitmaHizmetDisi === "0",
  );

  // gruplama ve sayma
  const grouped = filtered?.reduce((acc, item) => {
    const fiyat = item.isitmaFiyat;
    acc[fiyat] = (acc[fiyat] || 0) + 1;
    return acc;
  }, {});

  // string çıktısı üretme
  const IsitmaComp = () => {
    if (!grouped) return null;
    const entries = Object.entries(grouped);
    return (
      <>
        {entries.map(([fiyat, count], index) => (
          <span key={fiyat}>
            <DefaultCurrencyFormat
              Symbol={result.result.symbol}
              value={fiyat}
            />{" "}
            x {count}
            {index < entries.length - 1 ? ", " : ""}
          </span>
        ))}
      </>
    );
  };

  return (
    <div className="flex flex-col">
      {!isAppWebView && (
        <div className="sm:hidden">
          <DiscountBannerMobile src="/images/discount-banner-mobile.png" />
        </div>
      )}
      <div className="bg-detail-border-color px-7 pt-4 pb-2">
        <span className="mb-3 font-semibold text-base tracking-11 text-orange">
          {reservationSummary}
        </span>

        <div className="text-13 flex justify-between mt-3 items-center">
          <span className="font-medium opacity-60">
            {accommodationAmount.replace("{night}", result.result.night)}
          </span>
          <span
            className={`font-bold ${
              result.result.old_price || result.result.old_price2
                ? "line-through text-red-600"
                : ""
            }`}
          >
            <DefaultCurrencyFormat
              Symbol={result.result.symbol}
              value={
                result.result.old_price2 ||
                result.result.old_price ||
                result.result.accommodation_fee
              }
            />
          </span>
        </div>
        {result.result.IndirimTutari > 0 && (
          <div className="text-13 flex justify-between mt-3 items-center">
            <span className="font-medium opacity-60">
              {isAppWebView && result?.result?.MobileOzel
                ? mobileAppDiscount
                : discount}
            </span>
            <span className="font-bold text-green-600">
              <DefaultCurrencyFormat
                Symbol={result.result.symbol}
                value={result.result.IndirimTutari}
              />
            </span>
          </div>
        )}
        {result.result.PromotionDiscountPrice > 0 && (
          <div className="text-13 flex justify-between mt-3 items-center">
            <span className="font-medium opacity-60">
              {result?.MobileOzel == true
                ? mobileAppDiscount
                : promoCodeDiscount}
            </span>
            <span className="font-bold text-green-600">
              <DefaultCurrencyFormat
                Symbol={result.result.symbol}
                value={result.result.PromotionDiscountPrice}
              />
            </span>
          </div>
        )}
        {result.result.old_price || result.result.old_price2 ? (
          <div className="text-13 flex justify-between mt-3 items-center">
            <span className="font-medium opacity-60">
              {discountedAccommodationAmount}
            </span>
            <span className="font-bold">
              <DefaultCurrencyFormat
                Symbol={result.result.symbol}
                value={result.result.accommodation_fee}
              />
            </span>
          </div>
        ) : (
          ""
        )}

        {result.result.cleaning_fee ? (
          <div className="text-13 flex justify-between mt-3 items-center">
            <span className="font-medium opacity-60">{cleaningFee}</span>
            <span className="font-bold">
              <DefaultCurrencyFormat
                Symbol={result.result.symbol}
                value={result.result.cleaning_fee}
              />
            </span>
          </div>
        ) : (
          ""
        )}
        {buyPool && result.result.isitmaHizmetDisi != "1" ? (
          <>
            <div className="text-13 flex justify-between mt-3 items-center">
              <span className="font-medium opacity-60">
                {heatedPool}{" "}
                <span className="font-bold text-black">
                  (<IsitmaComp />)
                </span>
              </span>
              <span className="font-bold">
                {result.result.pool_fee ? (
                  <DefaultCurrencyFormat
                    Symbol={result.result.symbol}
                    value={result.result.pool_fee}
                  />
                ) : (
                  free
                )}
              </span>
            </div>
          </>
        ) : (
          ""
        )}

        {mandatoryServices?.length > 0 && (
          <div className="w-full border-t border-black border-opacity-10 mt-4 pt-4">
            {mandatoryServices?.map((service, index) => (
              <div className="mb-3 last:mb-0" key={`man-${index}`}>
                <ServiceRow
                  service={service}
                  symbol={result?.result?.symbol}
                  isOptional={false}
                  isSelected={true}
                  AvailableExtraServices={AvailableExtraServices}
                />
              </div>
            ))}
          </div>
        )}

        {optionalServices?.length > 0 && (
          <div className="w-full mt-6 mb-2 border-b border-black border-opacity-10 pb-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px bg-black bg-opacity-10 flex-grow"></div>
              <span className="text-13 font-bold opacity-80 whitespace-nowrap">
                {optionalServicesTitle}
              </span>
              <div className="h-px bg-black bg-opacity-10 flex-grow"></div>
            </div>
            <div className="px-2">
              {optionalServices.map((service, index) => (
                <div className="mb-4 last:mb-0" key={`opt-${index}`}>
                  <ServiceRow
                    AvailableExtraServices={AvailableExtraServices}
                    service={service}
                    symbol={result?.result?.symbol}
                    isOptional={true}
                    isSelected={selectedServices?.has(service.id)}
                    onServiceChange={handleServiceChange}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {result.result.cleaning_fee ||
        result.result.extra_price > 0 ||
        (result.result.pool_fee &&
          buyPool &&
          result.result.isitmaHizmetDisi != "1") ? (
          <div className="text-13 flex justify-between mt-3 items-center">
            <span className="font-medium opacity-60">{totalPrice}</span>
            <span className="font-bold">
              {" "}
              <DefaultCurrencyFormat
                Symbol={result.result.symbol}
                value={result.result.total_price}
              />
            </span>
          </div>
        ) : (
          ""
        )}
      </div>

      {((result.result.deposit_price > 0 && paymentType !== "all") ||
        (result.result.remaining_price > 0 && paymentType !== "all")) && (
        <div className="bg-gray-200 px-7 py-3">
          {result.result.deposit_price > 0 && paymentType !== "all" && (
            <div className="text-13 flex justify-between items-center">
              <span className="font-medium opacity-60">{depositPrice}</span>
              <span className="font-bold">
                <DefaultCurrencyFormat
                  Symbol={result.result.symbol}
                  value={result.result.deposit_price}
                />
              </span>
            </div>
          )}
          {result.result.remaining_price > 0 && paymentType !== "all" && (
            <div className="text-13 flex justify-between mt-3 items-center">
              <span className="font-medium opacity-60">{remainingAmount}</span>
              <span className="font-bold">
                <DefaultCurrencyFormat
                  Symbol={result.result.symbol}
                  value={result.result.remaining_price}
                />
              </span>
            </div>
          )}
        </div>
      )}
      <div className="bg-detail-border-color px-7 py-1"></div>
    </div>
  );
};

export default Result;
